/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import DeleteDocumentSouscriptionSupportingDocumentsMutation from '../graphql/mutations/DeleteDocumentSouscriptionSupportingDocumentsMutation.js';

export const useDeleteDocumentSouscriptionSupportingDocumentsMutation = () => {
  return useCommitMutation(DeleteDocumentSouscriptionSupportingDocumentsMutation, {
    dataProp: 'deleteDocumentSouscriptionSupportingDocuments_M_souscription_supporting_documents'
  });
};

export default useDeleteDocumentSouscriptionSupportingDocumentsMutation;
